import { render, staticRenderFns } from "./setServerAutoLogin.vue?vue&type=template&id=6b837f5e&scoped=true&"
import script from "./setServerAutoLogin.vue?vue&type=script&lang=js&"
export * from "./setServerAutoLogin.vue?vue&type=script&lang=js&"
import style0 from "./setServerAutoLogin.vue?vue&type=style&index=0&id=6b837f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b837f5e",
  null
  
)

component.options.__file = "setServerAutoLogin.vue"
export default component.exports